var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeNota(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222.23 180.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-nota{fill:#ff3b83;}.cls-2-nota{fill:#ffc300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Resume_new",
    "data-name": "Icone Resume new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-nota",
    d: "M97.55,180.72a34.07,34.07,0,1,1,34.07-34.07A34.1,34.1,0,0,1,97.55,180.72Zm0-60.84a26.78,26.78,0,1,0,26.77,26.77A26.81,26.81,0,0,0,97.55,119.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-nota",
    x: 124.4,
    width: 7.3,
    height: 146.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nota",
    d: "M195.68,82.3l-6.13,21.23,17.29-4.45-22.47,37.28,3.79-21.23-18,4.67,9.56-33.34,16-4.16M206.25,72l-12.4,3.21-16,4.09-4,1-1.17,4-9.55,33.34-3.51,12.26L172,126.73l7-1.82-1.83,10-7,39,20.43-33.92L213,102.65l9.19-15.24-17.29,4.45-4.89,1.24,2.56-8.9L206.25,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nota",
    d: "M26.63,20.36l16,4.08,9.56,33.34-18-4.66,3.8,21.23L15.47,37.06l17.29,4.45L26.63,20.36M16.05,10.07l3.58,12.26,2.55,8.9L17.29,30,0,25.54,9.19,40.79,31.66,78.07,52.09,112l-7-39L43.26,63l7,1.82L62.6,68.07,59.1,55.81,49.54,22.47l-1.17-4-4-1-16-4.09L16.05,10.07Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNota);
export default __webpack_public_path__ + "static/media/home-nota.d5a509ee675ac45ec7b86aa7e3d9b145.svg";
export { ForwardRef as ReactComponent };